<template>
  <v-main style="padding-top:50px;">
    <v-container v-show="pageLoaded" style="max-width:500px; margin-left:0px;">
      <div class="avatar-wrapper">
        <div ref="imageUploadDiv" class="image-upload-div"></div>
      </div>
      <h3 class="user-profile-header">Name</h3>
      <p>{{displayName}}</p>
      <h3 class="user-profile-header">About</h3>
      <p>{{aboutMe}}</p>
      <div class="user-badges-section">
        <h3 class="user-profile-header">Badges</h3>
        <v-card flat>
          <div v-if="userPaddles.length" class="first-contributor-badge"> 
          </div> 
        </v-card>
      </div>
      <div class="added-paddles-section">
        <h3 class="user-profile-header">Paddles Added</h3>
        <v-card v-for="paddle in userPaddles" :key="paddle._id" style="margin-top:10px;">
          <v-card-title v-if="paddle.published" class="paddle-title" @click="goToFeaturedPaddle(paddle)">
            {{ paddle.paddleName }}
          </v-card-title>      
        </v-card>
      </div>
    </v-container>
    <div v-show="!pageLoaded" class="spinner-container">
      <v-progress-circular
        indeterminate
        color="accent"
        :size="60"
      ></v-progress-circular>
    </div>
  </v-main>
</template>

<script>
  import NODE_API from '../utils/api';
  import constants from '../utils/constants'; 
  import NavBar from '../components/NavBar.vue';
  import { Auth } from 'aws-amplify';
  import ConfirmDialog from '../components/ConfirmDialog.vue';
  import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
  import { nextTick } from 'vue';
  const API_KEY = process.env.VUE_APP_API_KEY;
  import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
  import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
 import { defineComponent, ref, reactive, onUnmounted } from "vue";
import { Cropper, CircleStencil } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import {getResizedCanvas} from '../utils/files'; 

  export default {
    name: 'UserProfileRead',
    components: {
      NavBar,
      ConfirmDialog,
      Cropper,
    },
    props: {
      userId: String,
      isInDialog: Boolean
    },
    emits: ['close'],
    async created() {
      let {username} = this.$route.params; 
      //the preferred username might be tacked on the end if it's different to the username
      let justTheUsername = username.split('/')[0]; 

      try {
        let response = await NODE_API.get(`${constants.amazonGatewayUrl}/userMetadata?username=${justTheUsername}&profile=true`);
        this.userMetadata = response.data.ret;     
      
        if (!this.userMetadata) {
          //this can happen if the user object wasn't added to mongo - 
          //the post confirmation handler didn't fire. 
          //which could happen for those users who we manually imported, and reset passwords for
        } else {
          this.displayName = this.userMetadata.preferredUsername; 
          this.aboutMe = this.userMetadata.aboutMe; 
          this.userObjectId = this.userMetadata._id; 
          this.theAvatarFilePath = this.userMetadata.avatarFilePath; 
        
          let body = JSON.stringify({
            filePath: this.userMetadata.avatarFilePath,
            type: 'getObject',
            userImage: true 
          }); 

          try {
              //signed url for get avatar
              let signedUrlResponse = await NODE_API.post(`${constants.amazonGatewayUrl}/getSignedUrl`, body,{
                headers: {
                  'Content-Type': 'application/json'
                }
              }); 

              let backgroundImageUrl = signedUrlResponse.data.uploadUrl; //should not be called uploadUrl in this case. its for the get.     
              const avatarCircle = document.querySelector('.image-upload-div'); 
              avatarCircle.style.backgroundImage = `url(${backgroundImageUrl})`; 
        
          } catch (e) {
              console.error('could not load avatar',e); 
          }

            try {
            let response = await NODE_API.get(`${constants.amazonGatewayUrl}/paddles?username=${justTheUsername}`); 
      
            this.userPaddles = response.data.ret.userPaddles;
            
            console.log('the user paddles',this.userPaddles); 
            // this.myPaddlesLoaded = true; 
          } catch (e) {
            console.error(e); 
          }
        }
      } catch (e) {
        console.error(e); 
      }
      
      this.pageLoaded = true; 
      
    },
    mounted() {
    },
    setup() {
    
      const image = reactive({
        src:"",
        type:""
      });
      console.log('image',image); 
      onUnmounted(() => {
        // Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (image.src) {
          URL.revokeObjectURL(image.src);
        }
      });

      return {
        image,
      
        getFeaturedImgSrc(images) {
          if(!images) return; 
          let theFeatured = images.find((image) => image.order == 1); 
          if (theFeatured) {
            let nLastSlash = theFeatured.url.lastIndexOf('/'); 
            let thumbnailPath = theFeatured.url.substring(0, nLastSlash + 1) + '400w-' + theFeatured.url.substring(nLastSlash + 1); 

            return 'url(' + constants.imgResizedBaseUrl + thumbnailPath + ')';
          } else {
            return ''; 
          } 
        }
      }
    },
    methods: { 
      goToFeaturedPaddle(paddle) {
        this.$router.push(`/map/${paddle.paddleNameSlug}`); 
      },
    },
    computed: {
    
    },
    data: () => ({  
      userObjectId: null, 
      user: null,
      displayName: '',
      aboutMe: '',
      showErrorMessage: '',
      errorMsg: '',
      pageLoaded: false,
      overlay: false,
      dialog:false, 
      theAvatarFilePath: '',
      userPaddles: []
    }),
  }
</script>

<style lang="scss" scoped>
.first-contributor-badge { 
    background-image: url('../assets/user_badges/first_contributor_badge.png'); 
    background-size: cover;
    background-position: center center;
    padding-top: 30%;
    width: 100px;
}
.user-badges-section {
  padding-top: 20px; 
}
.added-paddles-section {
  padding-top:20px; 
  .paddle-title.v-card-title {
    font-size:16px; 
    cursor:pointer; 
  }
}
.user-profile-header {
  font-size: 0.875em;
  opacity: var(--v-medium-emphasis-opacity);
  font-weight:normal; 
}
.avatar-upload-in-progress {
  position: absolute;
  right: 5px;
  bottom: -1px;
  width: 21px;
}
.hint {
  font-size:12px; 
  line-height:14px; 
  display:block; 
  text-align:left; 
  padding-left:5px; 
  padding-bottom:5px; 
  color:gray; 
  margin-bottom:10px; 
  
}
.avatar-wrapper {
  width:200px; 
  margin-bottom:10px; 
  position:relative; 
}
.crop-image-btn {
  position: absolute;
  width: 50px;
  color: white !important;
  padding: 0px;
  font-size: 20px;
  bottom:10px; 
  right:10px; 
}
.image-upload-div {
  margin: 0 auto 10px; 
  background-size: cover; 
  background-position: center; 
  background-repeat: no-repeat;
}
.upload-avatar-btn {
  font-size: 12px!important;
  padding: 0px 0px!important;
  min-width: 0px;
  width: 130px !important;
  color:white!important;
  margin:0 auto;
  display:block;
}
.save-btn {
  color:white!important;
  width:200px!important; 
}
.cropper {
  max-height: 500px;
  max-width:500px;
}
.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 17px;
}

.button {
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  width: 100%;
  background: #151515;
  cursor: pointer;
  transition: background 0.5s;
  border: none;
  &:not(:last-of-type) {
    margin-right: 10px;
  }
  &:hover {
    background: #2F2F2F;
  }
  input {
    display: none;
  }
}
  #minimap {
    width:250px; 
    height:300px; 
  }
  #geocoder {
    z-index: 1;
    margin-left: 10px;
    margin-top:-10px; 
  }
  .mapboxgl-ctrl-geocoder {
    min-width: 100%;
  }
  .save-user-settings-btn {
    margin-top:35px; 
  }
  .error-msg {
    min-height:0px!important;
    font-size:12px;
    line-height:15px;
    color: rgb(var(--v-theme-error)); 
  }
  .spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
  }
  .settings-location-hint {
    font-size: 12px;
    vertical-align: middle;
    padding-top: 29px;
    display: inline-block;
    padding-left: 20px;
    max-width:300px; 
  }
  .image-upload-div {
    background-color:lightgray;  
    border-radius: 50%;
    cursor: pointer;
    height: 100px;
    width: 100px;
    margin-bottom: 10px;
  }
</style>
